export { default } from '@esentai/core/features/parkingWhitelist/api';
